import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: ['data'],
    failure: ["error"],
    reset: [],
  },
  { prefix: "IMPORT_WHITEOFF_FOB_" }
);

export interface ImportWriteOffFobState extends IState {
  data: [];
}

export interface ImportWriteOffSuccess extends ISuccessAction {
  data: [];
}

const INITIAL_STATE: ImportWriteOffFobState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ImportWriteOffFobState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ImportWriteOffFobState,
  action: ImportWriteOffSuccess
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ImportWriteOffFobState, action: IFailureAction) =>
  update(state, {
	data: { $set: []},
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const importWriteOffFob = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ImportWriteOffFobTypes = Types;
export const ImportWriteOffFobActions = Creators;
